import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowCrumb",
  "use": "arrowCrumb-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrowCrumb\">\n<path d=\"M11.734 16.0162L14.1082 13.6421C14.4657 13.2846 14.4657 12.7071 14.1082 12.3496L11.734 9.9754C11.1565 9.40707 10.1665 9.8104 10.1665 10.6262V15.3654C10.1665 16.1904 11.1565 16.5937 11.734 16.0162Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol